import styled from "styled-components";

export const PrivacySection = styled.section`
    display: grid;
    gap: 8px;
`;

export const PrivacyLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    color: #344054;
    font-size: 14px;
    font-weight: 500;
`;

export const InfoIcon = styled.img`
    width: 16px;
    height: 16px;
`;

export const PrivacyDescription = styled.div`
    color: #667085;
    font-size: 11px;
    line-height: 16px;
`;

export const PrivacyCard = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px;
    border: 1px solid #d6d6d6;
    border-radius: 10px;
    box-sizing: border-box;
`;

export const PrivacyTitle = styled.div`
    color: #101828;
    font-size: 13px;
    font-weight: 500;
`;

export const PrivacySubtitle = styled.div`
    margin-top: 2px;
    color: #667085;
    font-size: 11px;
    line-height: 16px;
`;

export const Toggle = styled.button<{ enabled: boolean }>`
    position: relative;
    flex: 0 0 36px;
    width: 36px;
    height: 20px;
    padding: 0;
    border: 0;
    border-radius: 999px;
    appearance: none;
    background: ${({ enabled }) => (enabled ? "#700AC1" : "#D1D5DB")};
    cursor: pointer;
    transition: background 0.2s ease;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const ToggleThumb = styled.span<{ enabled: boolean }>`
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #ffffff;
    transform: translateX(${({ enabled }) => (enabled ? "16px" : "0")});
    transition: transform 0.2s ease;
`;
